module.exports = __webpack_public_path__ + "img/literature5.f85bf01b.png";